import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Search, TrendingUp, TrendingDown } from "lucide-react";
import BannerAd from "./BannerAd";
import ArticleCard from "./ArticleCard";
import { NAV_CATEGORIES } from "../mock";
import { fetchArticles, fetchMarketIndices } from "../api";

const Sidebar = ({ showBottomAd = true }) => {
  const [q, setQ] = useState("");
  const [highlights, setHighlights] = useState([]);
  const [indices, setIndices] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    fetchArticles({ featured: true, limit: 4 })
      .then(setHighlights)
      .catch(() => setHighlights([]));
    fetchMarketIndices()
      .then(setIndices)
      .catch(() => setIndices([]));
  }, []);

  const submit = (e) => {
    e.preventDefault();
    if (q.trim()) navigate(`/cerca?q=${encodeURIComponent(q.trim())}`);
  };

  return (
    <aside className="space-y-8">
      <div>
        <span className="sq-heading">Cerca</span>
        <form onSubmit={submit} className="flex mt-4">
          <input
            value={q}
            onChange={(e) => setQ(e.target.value)}
            placeholder="Cerca..."
            className="flex-1 px-3 py-2.5 text-sm border border-sq rounded-l-sm outline-none focus:border-sq-orange"
          />
          <button className="bg-sq-orange hover:bg-sq-orange-dark transition-colors text-white px-5 rounded-r-sm text-sm font-medium">
            <Search size={16} />
          </button>
        </form>
      </div>

      <BannerAd id="sidebar-top" label="Spazio Pubblicitario" />

      <div>
        <span className="sq-heading">Mercati in tempo reale</span>
        <div className="mt-4 border border-sq rounded-sm divide-y divide-[#e6e8ec]">
          {indices.map((m) => (
            <div key={m.name} className="flex items-center justify-between px-4 py-2.5">
              <span className="text-sm font-medium text-sq-navy">{m.name}</span>
              <div className="flex items-center gap-2">
                <span className="text-sm text-gray-600">{m.value}</span>
                <span
                  className={`text-xs font-semibold flex items-center gap-0.5 ${
                    m.up ? "text-emerald-600" : "text-red-600"
                  }`}
                >
                  {m.up ? <TrendingUp size={12} /> : <TrendingDown size={12} />}
                  {m.change}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div>
        <span className="sq-heading">In evidenza</span>
        <div className="mt-4 space-y-5">
          {highlights.map((a) => (
            <ArticleCard key={a.id} article={a} variant="horizontal" />
          ))}
        </div>
      </div>

      <div>
        <span className="sq-heading">Categorie</span>
        <ul className="mt-4 border border-sq rounded-sm divide-y divide-[#e6e8ec]">
          {NAV_CATEGORIES.map((c) => (
            <li key={c.slug}>
              <Link
                to={`/categoria/${c.slug}`}
                className="flex items-center justify-between px-4 py-3 text-sm text-sq-navy hover:bg-sq-light hover:text-sq-orange transition-colors"
              >
                {c.name}
                <span className="text-gray-400">›</span>
              </Link>
            </li>
          ))}
        </ul>
      </div>

      {showBottomAd && <BannerAd id="sidebar-bottom" label="Spazio Pubblicitario" />}
    </aside>
  );
};

export default Sidebar;
